export const NUM_PARAMS = [[ 'impressions', 'Impressions' ], [ 'clicks', 'Clicks' ], [ 'spent', 'Spent' ], [ 'revenue', 'Revenue' ], [ 'onwRevenue', 'Onw Revenue' ], [ 'totalRevenue', 'Total Revenue' ], [ 'bid', 'Bid' ], [ 'roi', 'ROI' ], [ 'roiPercent', 'ROI %' ], [ 'onwRoi', 'Onw ROI' ], [ 'proposedBid', 'Proposed Bid' ]];
export const PARAMS = [ [ 'feed', 'Feed' ], [ 'subid', 'Subid'], [ 'country', 'Country'], [ 'list', 'List' ], ...NUM_PARAMS ];
export const PAGE_LIMIT = 100;


// WEBPACK FOOTER //
// ./src/scenes/AdKernel/config.js